import { render, staticRenderFns } from "./DeCenter.vue?vue&type=template&id=a538973c"
import script from "./DeCenter.vue?vue&type=script&lang=js"
export * from "./DeCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports